import { levierColorTokenFor, stepDecorationClasses } from '@/lib/display-tweaks';
import { cn } from '@/lib/utils';
import { FAKE_COMPANY, FAKE_LEVIER_ORDERS } from './fake-company';
import { PreviewFrame } from './preview-frame';
import type { SettingPreviewProps } from './setting-preview-props';
import { SkeletonBar } from './skeleton-bar';

const HEADERS = ['Étape', 'Driver', 'Levier de valeur'] as const;

/** `singularity-step-decoration`: the six setup steps, decorated by the same classes as the real table. */
export function StepDecorationPreview({ value }: SettingPreviewProps) {
  return (
    <PreviewFrame>
      <table className="w-full border-separate border-spacing-0 text-small">
        <thead>
          <tr>
            {HEADERS.map((header) => (
              <th key={header} className="px-2 py-1 text-left font-bold text-gray-500 text-small">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {FAKE_LEVIER_ORDERS.map((order) => {
            const classes = stepDecorationClasses(
              value,
              levierColorTokenFor(FAKE_COMPANY.noyau, order),
            );
            return (
              <tr key={order}>
                <td
                  className={cn(
                    classes.cell,
                    classes.firstCell,
                    'whitespace-nowrap px-2 py-1 align-middle font-bold text-gray-500',
                  )}
                >
                  {classes.dot && (
                    <span
                      className={cn(
                        'mr-1 inline-block h-2 w-2 rounded-full align-middle',
                        classes.dot,
                      )}
                    />
                  )}
                  Étape {order}
                </td>
                <td className={cn(classes.cell, 'px-2 py-1 align-middle')}>
                  <SkeletonBar width={85} />
                </td>
                <td className={cn(classes.cell, 'px-2 py-1 align-middle')}>
                  <SkeletonBar width={70} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </PreviewFrame>
  );
}
